// extracted by mini-css-extract-plugin
module.exports = {"crossBorderHeader":"style_crossBorderHeader__m4EQR"};